import React from "react";
import Modal from "../../../Common/Modal";
import GrClose from "@meronex/icons/gr/GrClose";
import PhoneNumber from "../PhoneNumber";
import MdcContentCopy from "@meronex/icons/mdc/MdcContentCopy";
import RedeemAnimation from "../RedeemButtonAnimation";
import DealEnquiry from "../../../DealEnquiry";
import BsArrowRight from "@meronex/icons/bs/BsArrowRight";
import { AlertSvg } from "./Components/SVG";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function DealRedemptionModal(_ref) {
  var _config$deals, _config$deals2, _deal$vendor;
  var visible = _ref.visible,
    onClose = _ref.onClose,
    captureUserMobile = _ref.captureUserMobile,
    setCaptureUserMobile = _ref.setCaptureUserMobile,
    _redeemNowClickedHandler = _ref.redeemNowClickedHandler,
    deal = _ref.deal,
    isBundleDeal = _ref.isBundleDeal,
    isVoucherDeal = _ref.isVoucherDeal,
    isCodeDeal = _ref.isCodeDeal,
    isOnlineDeal = _ref.isOnlineDeal,
    voucherCode = _ref.voucherCode,
    copiedText = _ref.copiedText,
    handleCopyCode = _ref.handleCopyCode,
    config = _ref.config,
    modalMessage = _ref.modalMessage,
    isOfflineDeal = _ref.isOfflineDeal,
    redemptionId = _ref.redemptionId,
    prefilledData = _ref.prefilledData,
    isOfflineTag = _ref.isOfflineTag,
    history = _ref.history;
  return /*#__PURE__*/_jsxs(Modal, {
    visible: visible,
    onClick: onClose,
    className: "w-[97%] md:w-[55%] lg:w-[45%] xl:w-[35%] 2xl:w-[30%] 3xl:w-[25%]",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-between px-4 mt-4 -mb-2 ",
      children: /*#__PURE__*/_jsx(GrClose, {
        onClick: onClose,
        className: " h-4 w-4 cursor-pointer self-end ml-auto z-10"
      })
    }), captureUserMobile && /*#__PURE__*/_jsx(PhoneNumber, {
      redeemNowClickedHandler: function redeemNowClickedHandler(mobile) {
        return _redeemNowClickedHandler({
          url: deal.url,
          id: deal.id,
          redemptionType: deal === null || deal === void 0 ? void 0 : deal.redemptionType,
          mobile: mobile
        });
      },
      setCaptureUserMobile: setCaptureUserMobile
    }), !captureUserMobile && /*#__PURE__*/_jsxs("div", {
      className: "relative pt-4 flex flex-col",
      children: [/*#__PURE__*/_jsx("p", {
        className: "\n                        ".concat(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && (_config$deals = _config$deals.dealsSection) !== null && _config$deals !== void 0 && _config$deals.subAdditionalTextClass ? config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.dealsSection) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.subAdditionalTextClass : "", " z-10 mt-2 px-4 text-center font-semibold "),
        children: isBundleDeal ? /*#__PURE__*/_jsxs("p", {
          children: ["Thank you for redeeming the exciting offers part of this Housewarming Kit. You will be communicated the steps to redeem shortly.", ' ']
        }) : isVoucherDeal || isCodeDeal ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex flex-col justify-center items-center \n                                              ".concat((deal === null || deal === void 0 ? void 0 : deal.redemptionType) === 'VOUCHE' ? 'border-b-[2px] border-gray-200 pb-3' : '', "\n                                            "),
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-black uppercase font-semibold text-[26px]",
              children: "Congratulations!"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-black text-[16px]",
              children: (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === 'VOUCHER' ? 'Here are your voucher details' : 'Here are your coupon details'
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-2",
            children: (isCodeDeal || isVoucherDeal && isOnlineDeal) && voucherCode && /*#__PURE__*/_jsx("div", {
              className: "flex flex-col justify-between items-center",
              children: /*#__PURE__*/_jsxs("div", {
                className: "flex my-2 justify-center items-center",
                children: [!copiedText && /*#__PURE__*/_jsxs("div", {
                  onClick: function onClick() {
                    return handleCopyCode();
                  },
                  title: "Click to copy ",
                  className: " py-3 flex justify-center items-center gap-[2px] cursor-pointer rounded border-2  border-[#5ea4c7] border-dashed px-8  bg-[#eaf1f6b3]",
                  children: [/*#__PURE__*/_jsx("p", {
                    className: " z-10 text-[18px] font-semibold text-center text-black ".concat(config !== null && config !== void 0 && config.darktheme ? 'hover:border-[#68BBE3]' : 'hover:border-blue-900'),
                    children: voucherCode
                  }), ' ', /*#__PURE__*/_jsx(MdcContentCopy, {
                    className: "text-[20px] font-bold ml-2 text-gray-700"
                  })]
                }), copiedText && /*#__PURE__*/_jsx("p", {
                  className: "z-10 self-center font-normal animate-pulse ".concat(config !== null && config !== void 0 && config.darktheme ? 'bg-[#68BBE3B3]  text-white' : 'bg-[#154F9D1A] text-[#006EB7]', "   py-3 px-12 text-[18px] rounded "),
                  children: "Code Copied"
                })]
              })
            })
          }), modalMessage && /*#__PURE__*/_jsxs("div", {
            className: "mx-6 mt-6 flex gap-3 items-start rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3",
            children: [/*#__PURE__*/_jsx("div", {
              className: "animate-pulse w-12 h-auto text-yellow-500",
              children: AlertSvg
            }), /*#__PURE__*/_jsx("p", {
              className: "text-left text-gray-500",
              children: modalMessage
            })]
          }), isOfflineDeal && /*#__PURE__*/_jsxs("div", {
            className: "px-6 my-6 flex flex-col items-center",
            children: [/*#__PURE__*/_jsx("div", {
              className: "border border-dashed border-gray-300 rounded-xl p-5",
              children: /*#__PURE__*/_jsx("img", {
                src: voucherCode,
                alt: "Voucher QR",
                className: "w-44 h-44 object-contain"
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "mt-3 text-sm text-gray-600 flex items-center gap-2",
              children: [/*#__PURE__*/_jsx("span", {
                children: "\uD83D\uDCCD"
              }), "Show this code at the store to redeem"]
            })]
          })]
        }) : modalMessage ? modalMessage : /*#__PURE__*/_jsx("div", {
          className: " flex items-start justify-center text-left text-sm md:px-3 py-1 px-2 overflow-y-scroll pb-4 max-h-[80vh] scrollbar-thin",
          children: redemptionId && /*#__PURE__*/_jsx(DealEnquiry, {
            dealRedemptionId: redemptionId,
            prefilledData: prefilledData
          })
        })
      }), (isVoucherDeal && isOnlineDeal || isCodeDeal) && deal !== null && deal !== void 0 && deal.url ? voucherCode && !isOfflineTag && /*#__PURE__*/_jsx("div", {
        className: "flex flex-col justify-center items-center my-6",
        children: /*#__PURE__*/_jsx(RedeemAnimation, {
          content: "\n                                        Visit ".concat(deal === null || deal === void 0 || (_deal$vendor = deal.vendor) === null || _deal$vendor === void 0 ? void 0 : _deal$vendor.name, " to claim\n                                     "),
          onClick: function onClick() {
            window.open(deal === null || deal === void 0 ? void 0 : deal.url);
          },
          config: config
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("button", {
        onClick: function onClick() {
          history.push('/gift-and-earn');
        },
        className: "flex justify-center items-center mt-1 py-4 bg-[#e8f3fa] font-medium  text-[15px] lg:text-[17px] text-center",
        children: /*#__PURE__*/_jsxs("p", {
          children: ["Earn more rewards? Refer Now ", /*#__PURE__*/_jsx(BsArrowRight, {
            className: "inline mb-[1px]"
          })]
        })
      })]
    })]
  });
}
export default DealRedemptionModal;